/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyQuarterListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: SummaryofSalesbyQuarterService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { SummaryofSalesbyQuarterData, SummaryofSalesbyQuarterService } from './SummaryofSalesbyQuarter.service';
import { SummaryofSalesbyQuarterSearchComponent }  from './SummaryofSalesbyQuarterSearch.component';

@Component({
	selector: 'my-SummaryofSalesbyQuarter',
	template: require('./SummaryofSalesbyQuarterList.component.html'),
	providers: [SummaryofSalesbyQuarterService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class SummaryofSalesbyQuarterListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	SummaryofSalesbyQuarterList: SummaryofSalesbyQuarterData[];
	newSummaryofSalesbyQuarter: SummaryofSalesbyQuarterData;
	selectedSummaryofSalesbyQuarter: SummaryofSalesbyQuarterData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(SummaryofSalesbyQuarterSearchComponent) filterComponent: SummaryofSalesbyQuarterSearchComponent;

	sortExpression: string = "ShippedDate";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private SummaryofSalesbyQuarterService: SummaryofSalesbyQuarterService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newSummaryofSalesbyQuarter = new SummaryofSalesbyQuarterData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.SummaryofSalesbyQuarterService.getAll().subscribe(record => this.SummaryofSalesbyQuarterList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getSummaryofSalesbyQuarterByPaging();

		/*
		this.SummaryofSalesbyQuarterList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getSummaryofSalesbyQuarter() {
		this.SummaryofSalesbyQuarterService.getAll()
			.subscribe(data => this.SummaryofSalesbyQuarterList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on SummaryofSalesbyQuarterSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getSummaryofSalesbyQuarterByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getSummaryofSalesbyQuarterByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getSummaryofSalesbyQuarterByPaging();
	}
	
	// Get records by paging
	getSummaryofSalesbyQuarterByPaging() {
		this.SummaryofSalesbyQuarterService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.SummaryofSalesbyQuarterList=data.SummaryofSalesbyQuarterList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addSummaryofSalesbyQuarter() {
		this.SummaryofSalesbyQuarterService.addSummaryofSalesbyQuarterData(this.newSummaryofSalesbyQuarter).subscribe(record => console.log(record));
		this.getSummaryofSalesbyQuarter();
	}
  
	// Updates existing record
	updateSummaryofSalesbyQuarter() {
		this.SummaryofSalesbyQuarterService.updateSummaryofSalesbyQuarterData(this.selectedSummaryofSalesbyQuarter).subscribe(record => console.log(record));
		this.getSummaryofSalesbyQuarter();
	}

	// Deletes record with specified id
	deleteSummaryofSalesbyQuarter(id: string) {
		if (window.confirm('Are you sure you want to delete this SummaryofSalesbyQuarter?') == true)
		{
			this.SummaryofSalesbyQuarterService.deleteSummaryofSalesbyQuarter(id)
			.subscribe(data => this.getSummaryofSalesbyQuarter(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getSummaryofSalesbyQuarterByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getSummaryofSalesbyQuarterByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getSummaryofSalesbyQuarterByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getSummaryofSalesbyQuarterByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: SummaryofSalesbyQuarterData) {
		this.router.navigate(['/SummaryofSalesbyQuarter', item.ShippedDate]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: SummaryofSalesbyQuarterData) {
		this.router.navigate(['/SummaryofSalesbyQuarter/Details', item.ShippedDate]);
	}

	// Set record as selected
	SelectSummaryofSalesbyQuarter(item: SummaryofSalesbyQuarterData) {
		this.selectedSummaryofSalesbyQuarter = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: SummaryofSalesbyQuarterData) {
		return item.ShippedDate === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SummaryofSalesbyQuarter/SummaryofSalesbyQuarterList.component.ts